const Page = () => import('@/pages/page/Page.vue')
const Box = () => import('@/pages/page/Box.vue')
const Home = () => import('@/pages/home/HomeLayout.vue')

export default {
    path: '/page',
    component: Home,
    children: [
        {  path: ':alias', props: true, name: 'Page', component: Page },
        {  path: 'box/:alias', props: true, name: 'Box', component: Box },
    ]
}